// extracted by mini-css-extract-plugin
export default {"menu-layer0":"index_menu-layer0__STmG-","menu-layer1":"index_menu-layer1__E6V-T"};